// initial state
const state = {
  modal : {
    modalActive : false,
    modalName : 'WelcomeModal'
  }
}

// getters
const getters = {
  getModalActive : (state) => {
    return state.modal;
  }
}

// actions
const actions = {
 
}

// mutations
const mutations = {

  closeModal(state, modalName){
    state.modal.modalActive = false;
  },

  openModal(state, modalName){
    state.modal.modalActive = true;
    state.modal.modalName = modalName
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/modals.js